import { Action } from '@ngrx/store';
import { SearchResult } from '@shared/models/search/search-result';

export const SET_CARD_LIST = '[Map Results] Set Card List';
export const CLEAR_CARD_LIST = '[Map Results] Clear Card List';
export const ADD_TO_CARD_LIST = '[Map Results] Add To Card List';

export class SetCardList implements Action {
  readonly type = SET_CARD_LIST;
  constructor(public payload: Array<SearchResult>) {}
}

export class ClearCardList implements Action {
  readonly type = CLEAR_CARD_LIST;
}

export class AddToCardList implements Action {
  readonly type = ADD_TO_CARD_LIST;
  constructor(public payload: Array<SearchResult>) {}
}

export type mapResultsAction = SetCardList | ClearCardList | AddToCardList;
